import { DressupClothing } from "GameObjects/StoryGame/ch1/DressupClothing";
import { StickerButton } from "GameObjects/StoryGame/ch4/StickerButton";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Mix } from "Utils/Reflection";

export class StickerLayer extends HLF.Input.Receptacle {

    protected sprite = this._visuals.addChild(new PIXI.Sprite());
    protected lastClickPosition = {x: 0, y: 0};

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        if(typeof texture === 'string') {
            texture = texture.replace(/\.png$/, '');
            this.name = texture;
        }
        this.sprite.texture = (texture instanceof PIXI.Texture ? texture :
            texture ? HLF.PixiUtils.getTexture(texture) : PIXI.Texture.EMPTY) || PIXI.Texture.EMPTY;
        this.sprite.anchor.x = anchorX;
        this.sprite.anchor.y = anchorY;

        this.sprite.scale.set(0.5); // TODO: why?

        this.hitArea = new HLF.Input.PixelPerfectHitArea(HLF.Application.instance.renderer, this.sprite);
        this._visuals.mask = this.sprite;
    }

    protected addDraggable(pDraggable: HLF.Input.Draggable) {
        super.addDraggable(pDraggable);

        if (pDraggable instanceof StickerButton) {
            const newSticker = new PIXI.Sprite(pDraggable.stickerTexture);
            newSticker.anchor.set(0.5);
            newSticker.scale.set(0.5); // TODO: why?
            this._visuals.addChild(newSticker);

            const stickerPos = pDraggable.visuals.position;

            if (!stickerPos.equals({x: 0, y: 0})) { // if drag
                console.log('stick from drag');
                const globalPos = pDraggable.toGlobal(stickerPos);
                const localPos = this.toLocal(globalPos);
                newSticker.position.set(localPos.x, localPos.y);
            }
            else { // if click
                console.log('stick from click');
                newSticker.position.set(this.lastClickPosition.x, this.lastClickPosition.y);
            }

            PubSub.publishSync('stick', pDraggable);
        }
    }

    protected onPointerMove(pEvent: PIXI.InteractionEvent): void {
        this.lastClickPosition = pEvent.data.getLocalPosition(this);
        super.onTouchMove(pEvent); // sic
    }

    protected onPointerDown(pEvent: PIXI.InteractionEvent) {
        this.lastClickPosition = pEvent.data.getLocalPosition(this);
        super.onPointerDown(pEvent);
    }
}